var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "gfu-grid__cell gfu-1of3 _mt-1" },
        [
          _c("field-label", {
            staticClass: "gfu-field__label--gray _mt-1",
            attrs: { text: _vm.displayName },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gfu-grid gfu-grid--gutter-columns",
              attrs: { "data-qa": `filtersbox-field:${_vm.displayName}` },
            },
            [
              _c(
                "div",
                {
                  staticClass: "gfu-grid__cell gfu-6of12",
                  attrs: { "data-qa": "minValue" },
                },
                [
                  _c("number-field", {
                    attrs: {
                      inline: true,
                      integer: _vm.integer,
                      "show-label": false,
                      small: true,
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.applyFilter.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.value[_vm.minValueFieldName],
                      callback: function ($$v) {
                        _vm.$set(_vm.value, _vm.minValueFieldName, $$v)
                      },
                      expression: "value[minValueFieldName]",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "gfu-divider gfu-divider--small" }, [
                _vm._v("to"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "gfu-grid__cell gfu-6of12",
                  attrs: { "data-qa": "maxValue" },
                },
                [
                  _c("number-field", {
                    attrs: {
                      inline: true,
                      integer: _vm.integer,
                      "show-label": false,
                      small: true,
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.applyFilter.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.value[_vm.maxValueFieldName],
                      callback: function ($$v) {
                        _vm.$set(_vm.value, _vm.maxValueFieldName, $$v)
                      },
                      expression: "value[maxValueFieldName]",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }